// StatusApprovalStage2.js - Buttons aligned to right with transparent background
import React, { useState } from "react";
import axios from "axios";
import "./StatusApprovalStage2.css";
import { API_BASE } from "../../../ApiUrl";

const StatusApprovalStage2 = ({ professionalId, onSuccess }) => {
  const [showModal, setShowModal] = useState(false);
  const [actionType, setActionType] = useState("");
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(false);
  const [approveLoading, setApproveLoading] = useState(false);

  const tenantUser = JSON.parse(localStorage.getItem("tenant_user"));
  const reviewedBy = tenantUser?.user_id;

  const openModal = (type) => {
    setActionType(type);
    setReason("");
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  // Shared API call - Stage 2 professional review decision
  const submitStatus = async (decision, reasonText) => {
    await axios.post(
      `${API_BASE}/professional-reviews/${professionalId}/decision/`,
      {
        decision: decision,
        final_classification: "CANDIDATE",
        reviewed_by: reviewedBy,
        reason: reasonText || "",
        reviewer_notes: reasonText || "",
      }
    );
  };

  // Approve: no modal, no reason needed — submits immediately
  const handleApprove = async () => {
    try {
      setApproveLoading(true);
      await submitStatus("APPROVED", "");
      if (onSuccess) onSuccess();
    } catch (err) {
      console.error(err);
      alert("Something went wrong");
    } finally {
      setApproveLoading(false);
    }
  };

  // Return / Reject: go through modal with reason
  const handleSubmit = async () => {
    if (!reason.trim()) {
      alert("Please enter reason");
      return;
    }

    try {
      setLoading(true);
      await submitStatus(actionType, reason);
      setShowModal(false);
      if (onSuccess) onSuccess();
    } catch (err) {
      console.error(err);
      alert("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="status-actions-stage2">
        <button
          className="btn-stage2 approve-stage2"
          onClick={handleApprove}
          disabled={approveLoading}
        >
          {approveLoading ? "Approving..." : "Approve"}
        </button>

        <button
          className="btn-stage2 return-stage2"
          onClick={() => openModal("RETURNED")}
        >
          Return
        </button>

        <button
          className="btn-stage2 reject-stage2"
          onClick={() => openModal("REJECTED")}
        >
          Reject
        </button>
      </div>

      {/* MODAL - only for Return / Reject */}
      {showModal && (
        <div className="modal-overlay-stage2">
          <div className="modal-box-stage2">
            <h3>{actionType} Stage 2 Application</h3>

            <textarea
              placeholder="Enter reason..."
              value={reason}
              onChange={(e) => setReason(e.target.value)}
            />

            <div className="modal-actions-stage2">
              <button className="btn-stage2 cancel-stage2" onClick={closeModal}>
                Cancel
              </button>

              <button className="btn-stage2 submit-stage2" onClick={handleSubmit}>
                {loading ? "Submitting..." : "Submit"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default StatusApprovalStage2;